import { forwardRef } from 'react';
import type { CSSProperties, ReactNode } from 'react';

interface CardProps {
  title: string;
  icon?: ReactNode;
  description?: string;
  children?: ReactNode;
  style?: CSSProperties;
  background?: 'grey' | 'white' | 'translucent';
}

const Card = forwardRef<HTMLDivElement, CardProps>(function Card(
  { title, icon, description, children, style, background = 'grey' },
  ref
) {
  return (
    <article
      ref={ref}
      style={style}
      className={`p-6 py-7 backdrop-blur-[2px] flex flex-col rounded-md border border-[#C2C2C2] ${
        background === 'white' ? 'bg-white' : background === 'translucent' ? 'bg-[#ffffff3f]' : 'bg-[#fafafa]'
      }`}
    >
      {icon && (
        <div className='mb-2 rounded-full size-[38px] bg-[#4CC95A] flex items-center justify-center text-white'>
          <span className='size-5 flex items-center justify-center'>{icon}</span>
        </div>
      )}

      <h3 className='mb-1'>{title}</h3>

      {description && <p className='tracking-tight text-lg leading-5 text-[#525252] font-light'>{description}</p>}

      {children}
    </article>
  );
});

export default Card;
